import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=b3d27f6e&scoped=true"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"
import style0 from "./accordion.vue?vue&type=style&index=0&id=b3d27f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d27f6e",
  null
  
)

export default component.exports